import React from 'react';
import { BsChat, BsPerson, BsCheckCircle, BsStars } from 'react-icons/bs';

const features = [
    {
        icon: <BsChat />,
        title: 'Menu display',
        text: 'Present your food and drink menus online. Update items easily and keep layouts clear for guests.',
        width: '8', // col-md-8
    },
    {
        icon: <BsPerson />,
        title: 'Table booking',
        text: 'Let guests reserve tables online. Real-time availability and instant confirmations streamline the process.',
        width: '4', // col-md-4
    },
    {
        icon: <BsCheckCircle />,
        title: 'Event listings',
        text: 'Promote upcoming events and special offers. Update details quickly to keep guests informed.',
        width: '4',
    },
    {
        icon: <BsStars />,
        title: 'Online ordering',
        text: 'Let guests place pickup or delivery orders directly through your site. Integrated with your POS and easy to manage.',
        width: '8',
    },
];

function FeatureGrid() {
    return (
        <section className="feature-grid-section py-5">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="fw-semibold">Features That Work as Hard as Your Staff</h2>
                    <p className="text-muted">
                        Everything your guests expect. Delivered with clean, modern design and simple tools you control.
                    </p>
                </div>

                <div className="row gy-4">
                    {features.map((feature, idx) => (
                        <div className={`col-md-${feature.width}`} key={idx}>
                            <div className="feature-grid-card p-4 h-100">
                                <div className="feature-grid-icon mb-2">{feature.icon}</div>
                                <h5 className="fw-semibold mb-1">{feature.title}</h5>
                                <p className="mb-0">{feature.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default FeatureGrid;
